import React from 'react';
import styles from './game-block.module.scss';
import Button from "../Button";
import {UPLOADHOST} from "../../constants/constants";
import {useTranslation} from "react-i18next";

const GameBlock = ({ className, data }) => {
  const [t] = useTranslation("global");

  const { title = '', description, slug, images_for_preview_block } = data;
  const { button, main_image, other_images } = images_for_preview_block;

  return (
    <div className={`${styles.wrapper} ${className ? className : ''}`}>
      <div className={styles.row}>
        {
          main_image &&
            <div className={styles.video}>
              <img src={`${UPLOADHOST}${main_image.url}`} alt={'main img'} draggable="false"/>
            </div>
        }

        <div className={styles.images}>
          {
            other_images.map((img) => (
              <div key={img.id} className={styles.img}>
                <img src={`${UPLOADHOST}${img.url}`} alt={`image_${img.id}`} draggable="false"/>
              </div>
            ))
          }
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.titleWrapper}>
          <h3 className={styles.title}>{title}</h3>
        </div>
        <div className={styles.textPart}>
          <p>{ description }</p>
          { button &&
            <Button
              view={'light'}
              type={'link'}
              text={t("buttons.learn")}
              to={`/games/${slug}`}
              className={styles.button}
            />
          }
        </div>
      </div>
    </div>
  );
};

export default GameBlock;